
<!-- <div *ngIf="isDisplaypopup" class="modal fade" id="warning" tabindex="-1" role="dialog" aria-labelledby="warning" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body pt-0 px-0 pb-0">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <div class="bg-danger pt-1 mb-3"></div>
                            <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 0 192 192" fill="#f34d67" width="48"><path d="m186.015 130.209-64.507-104.2a30 30 0 0 0 -51.016 0l-64.507 104.2a30 30 0 0 0 25.508 45.791h129.014a30 30 0 0 0 25.508-45.791zm-6.289 26.5a21.734 21.734 0 0 1 -19.219 11.291h-129.014a22 22 0 0 1 -18.706-33.58l64.507-104.2a22 22 0 0 1 37.412 0l64.507 104.2a21.735 21.735 0 0 1 .513 22.287z"></path><path d="m172.411 138.631-64.511-104.203a14 14 0 0 0 -23.808 0l-64.507 104.2a14 14 0 0 0 11.908 21.372h129.014a14 14 0 0 0 11.9-21.369zm-68.411-2.631h-16v-16h16zm0-24h-16v-48h16z"></path></svg>
                            <h5 class="my-2">Warning</h5>
                            <p>{{message}}</p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-center">
          
                    <button mat-raised-button type="button" data-dismiss="modal" class="btn btn-danger">Close</button>
                </div>
            </div>
        </div>
    </div> -->

    <h1 mat-dialog-title>Hi </h1>
    <div mat-dialog-content>
        <p>What's your favorite animal?</p>
  <!-- <mat-form-field>
    <mat-label>Favorite Animal</mat-label>
   
  </mat-form-field> -->
    </div>
    <div mat-dialog-actions>
      
       <button mat-raised-button (click)="onNoClick()">Close</button> 
     
        </div>